import React from 'react';
import { FormattedMessage } from 'react-intl';

const AnnouncementCount = ({ index, count }) => (
  <span className="absolute right-30 f-12 top-5">
    <FormattedMessage id="notifications.announcements.count" values={{ index, count }} />
  </span>
);

export default AnnouncementCount;
